import { 
  collection, 
  doc, 
  setDoc, 
  getDoc, 
  getDocs,
  updateDoc, 
  deleteDoc,
  query
} from 'firebase/firestore';
import { db } from './config';
import { Gym } from '../../models/gym/Gym';

const GYMS_COLLECTION = 'gyms';

// Create a new gym document in Firestore
export const createGym = async (gym: Gym): Promise<Gym> => {
  try {
    console.log('Creating gym with ID:', gym.id);
    // Use the provided ID or generate a new one from doc
    const gymRef = doc(db, GYMS_COLLECTION, gym.id);
    
    // Remove undefined values before saving to Firestore
    const firestoreData = gym.toFirestore();
    console.log('Saving gym data to Firestore:', firestoreData);
    
    await setDoc(gymRef, firestoreData);
    console.log('Gym saved successfully with ID:', gym.id);
    return gym;
  } catch (error) {
    console.error('Error creating gym:', error);
    throw error;
  }
};

// Get a gym by ID
export const getGym = async (gymId: string): Promise<Gym | null> => {
  try {
    const gymRef = doc(db, GYMS_COLLECTION, gymId);
    const gymDoc = await getDoc(gymRef);
    
    if (gymDoc.exists()) {
      return Gym.fromFirestore({ ...gymDoc.data(), id: gymDoc.id });
    }
    
    return null;
  } catch (error) {
    console.error('Error getting gym:', error);
    throw error;
  }
};

// Get all gyms
export const getAllGyms = async (): Promise<Gym[]> => {
  try {
    const gymsQuery = query(collection(db, GYMS_COLLECTION));
    const querySnapshot = await getDocs(gymsQuery);
    
    const gyms: Gym[] = [];
    querySnapshot.forEach(doc => {
      gyms.push(Gym.fromFirestore({ ...doc.data(), id: doc.id }));
    });
    
    return gyms;
  } catch (error) {
    console.error('Error getting all gyms:', error);
    throw error;
  }
};

// Update a gym document
export const updateGym = async (gym: Gym): Promise<void> => {
  try {
    const gymRef = doc(db, GYMS_COLLECTION, gym.id);
    const firestoreData = gym.toFirestore();
    await updateDoc(gymRef, firestoreData);
  } catch (error) {
    console.error('Error updating gym:', error);
    throw error;
  }
};

// Delete a gym
export const deleteGym = async (gymId: string): Promise<void> => {
  try {
    const gymRef = doc(db, GYMS_COLLECTION, gymId);
    await deleteDoc(gymRef);
  } catch (error) {
    console.error('Error deleting gym:', error);
    throw error;
  }
};
